// extracted by css-extract-rspack-plugin
export default {"root":"SnowflakesButton_root__Nfxn0","icon":"SnowflakesButton_icon__DJlc0","icon_visible":"SnowflakesButton_icon_visible__U3wQy","pulse-once":"SnowflakesButton_pulse_once___QiTT"};